const depositList = {
  DIRECT_DEBIT: false,
  CHARGE: false,
  BONUS: false,
  REFUND_WAGE: false,
  REFUND: false,
  GIFT: false,
};

export default depositList;
